import { camelCase, snakeCase } from "es-toolkit/string";
import { mapKeys, toCamelCaseKeys, toSnakeCaseKeys } from "es-toolkit/object";
import { assertNotCircularObject } from "~/utils/assert";

type LooseObject = Record<string, unknown>;


export const mapKeysToCamelCase = <T extends object>(object: T): LooseObject => toCamelCaseKeys(object) as LooseObject;


const mapRootKeysTo = <T extends object>(object: T, cb: (key: string) => string): object =>
    mapKeys(object, (_, key) => cb(String(key)));

export const mapRootKeysToSnakeCase = <T extends object>(object: T): LooseObject =>
    mapRootKeysTo(object, snakeCase) as LooseObject;

export const mapRootKeysToCamelCase = <T extends object>(object: T): object => mapRootKeysTo(object, camelCase);


export const mapAllKeysToSnakeCase = <T extends object>(object: T): LooseObject => {
    assertNotCircularObject(object, "key-value dictionary");
    return toSnakeCaseKeys(object) as LooseObject;
};
